import axios from '@/utils/request'
import base from '../base'

export function userList(data) {
  return axios.post(`${base.url}/auth/user/list`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}

export function editUserList(data) {
  return axios.post(`${base.url}/auth/user/edit`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}

export function addUserList(data) {
  return axios.post(`${base.url}/auth/user/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}

export function delUserList(id) {
  return axios.get(`${base.url}/auth/user/del?id=${id}`)
}

export function userStatus(data) {
  return axios.get(`${base.url}/auth/user/status?id=${data.id}&status=${data.status}`)
}

export function resetPassword(data) {
  return axios.get(`${base.url}/auth/user/rePwd?id=${data.id}&password=${data.password}`)
}

export function roleBusiListAll(id) {
  return axios.get(`${base.url}/auth/business/listAll?companyId=` + `${id}`)
}

export function checkUserName(username) {
  return axios.get(`${base.url}/auth/user/getInfoByUserName?userName=` + `${username}`)
}


